import { w3cwebsocket as W3CWebSocket } from "websocket";
import { CONNECTION_STATUS, WS_URL } from "../ConstVariable";

class WebSocketConnection {

    constructor(webSocketConnectionStateCallBack, token, incrementNumberOfNewCallsCallback,user,SetSelectedWorkdeskConversation,getSelectedConversationId,UpdateConversationLogs) {
        let ws_url = `${WS_URL}/oi/api/v1/ws/${token}`
        this.webSocketConnectionStateCallBack = webSocketConnectionStateCallBack
        this.socket = new W3CWebSocket(ws_url);
        this.subscribeSocketEvents(this);
        this.webSocketOnMessageCallBack = null;
        this.incrementNumberOfNewCallsCallback = incrementNumberOfNewCallsCallback ;
        this.user = user;
        this.SetSelectedWorkdeskConversation=SetSelectedWorkdeskConversation;
        this.UpdateConversationLogs = UpdateConversationLogs;
        this.getSelectedConversationId = getSelectedConversationId;
    }

    getReadyState = () => {
        if (this.socket.readyState === 1) {
            return CONNECTION_STATUS.CONNECTED
        }

        if (this.socket.readyState === 2) {
            return CONNECTION_STATUS.CONNECTING
        }

        if (this.socket.readyState === 3) {
            return CONNECTION_STATUS.DISCONNECTED
        }
    }

    ping = () => {
        if (this.socket.readyState === 1) {
            this.socket.send(JSON.stringify({ "event": "PING" }))
        }
    }
    subscribeSocketEvents = (websocket_connection_obj) => {
        this.socket.onopen = () => {
            console.log("Socket connection is now OPEN!");
            this.webSocketConnectionStateCallBack(websocket_connection_obj, this.socket.readyState)
        }
        this.socket.onclose = () => {
            console.log("Socket connection is now CLOSED!");
            this.webSocketConnectionStateCallBack(null, this.socket.readyState)
        }
        this.socket.onerror = () => {
            console.log("Socket connection is now ERRORD!");
            this.webSocketConnectionStateCallBack(websocket_connection_obj, this.socket.readyState)

        }
        this.socket.onmessage = (in_msg) => {
          // console.log("Socket connection has a MESSAGE:" + in_msg.data);
          if (this.webSocketOnMessageCallBack != null) {
            this.webSocketOnMessageCallBack(in_msg.data);
          } else {
            const jsonMsg = JSON.parse(in_msg.data);
        
            switch (jsonMsg.event_type) {
              case "NEW_CALL":
                if (this.user?.oi_profile?.toLowerCase()=="demo" &&  this.getSelectedConversationId() == null) {
                  const latestSelectedConversationId = this.getSelectedConversationId(); 

                  this.SetSelectedWorkdeskConversation({
                    conversation_id: jsonMsg.conversation_id,
                    referral_form_status: "None",
                  });

                  if (jsonMsg.conversation_id) {
                  this.socket.send(
                    JSON.stringify({
                      conversation_id: jsonMsg.conversation_id,
                      operator_id: this.user?.email || "unknown@vengage.ai",
                      event: "CURRENT_OPERATOR",
                    })
                  );
                }
                }
        
                console.log("New call event captured in WebSocket.js");
                this.incrementNumberOfNewCallsCallback();
                break;
        
              case "CONVERSATION_DETAILS":
                if (this.user?.oi_profile?.toLowerCase()=="demo" &&  jsonMsg.conversation_id==this.getSelectedConversationId()) {
                  this.UpdateConversationLogs(jsonMsg?.details);
                }
                break;

              case "CALL_DISCONNECTED":
                console.log("Call disconnected for:", jsonMsg.conversation_id);
              default:
                break;
            }
          }
        };
    }
}

export default WebSocketConnection;
